import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { TASK_TERM } from "../apiRoutes";

interface TaskTermResponse {
  data: any;
}

const fetchTaskTermDetail = async (id: string) => {
  const response = await axiosAuth.get<TaskTermResponse>(
    `${TASK_TERM}${id}`
  );
  return response.data;
};

const useGetTaskTermDetailQuery = (
  id?: string,
  queryParams?: UseQueryOptions<any, Error, any, ["taskTermDetail", string | undefined]>
) =>
  useQuery<any, Error, any, ["taskTermDetail", string | undefined]>({
    queryKey: ["taskTermDetail", id],
    queryFn: () => fetchTaskTermDetail(String(id)),
    enabled: Boolean(id),
    ...(queryParams as any),
  });

export default useGetTaskTermDetailQuery;


